module.exports = "\r\n<wechat-msg></wechat-msg>";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/wechatMsg/index.html
// module id = 13
// module chunks = 0